import { array, object, string } from "yup"
import { useValidatorSeeker } from "@app"

import { acrissGroupFormData } from "Pages/User/Settings/AcrissGroupTab/@signals"


const schema = object({
	name: string().required('Name is required'),
	acriss: array().min(1, 'At least one acriss is required'),
})

export default function useAcrissGroupsValidator() {
	const { isValid, errors } = useValidatorSeeker(acrissGroupFormData.value, schema)

	return {
		isValid,
		nameError: errors.name || null,
		acrissError: errors.acriss || null,
	}
}
